import { connect } from 'react-redux';

import ResubmitCodeButton from './resubmit-code-button.component';
import { recycleRedemptionProcess } from '../redemption/redemption.actions';
import { Dispatch } from 'types/dispatch';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    onReSubmit: () => dispatch(recycleRedemptionProcess())
});

const ResubmitCodeButtonContainer = connect(
    null,
    mapDispatchToProps
)(ResubmitCodeButton);

export default ResubmitCodeButtonContainer;
